import erlang from "refractor/erlang";
export default erlang;